import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/dashboard'
export default {
  namespaced: true,
  state: {
    loading: false,
    counters: [],
    package: {
      package_name: null,
      expiration: null,
      diskUsage: {
        usage: null,
        limit: null,
        percent: null,
        variant: null,
      },
      users: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    counters(state) {
      return state.counters
    },
    package(state) {
      return state.package
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DASHBOARD(state, data) {
      state.counters = data.counters
      state.package = data.package
    },
  },
  actions: {
    getDashboard({ commit }, params) {
      commit('SET_LOADING', true)
      axiosIns
        .get(ROOT_URL, { params })
        .then(response => {
          commit('SET_DASHBOARD', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
